<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2z"><a id="page_viii"></a><a id="page_ix"></a><a id="abb"></a>TRANSLATIONS AND ABBREVIATIONS</h2>
<p class="centerx"><em>Unless otherwise noted, translations are my own</em>.</p>
<p class="noindent">Works by Mendelssohn</p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="35%"/>
<col width="65%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="tablet"><em>Bi’ur</em></p></td>
<td valign="top"><p class="table1t"><em>Sefer Netivot Hashalom</em> (<em>The Book of the Paths of Peace</em>, often referred to as the <em>Bi’ur</em> or <em>Elucidation</em>). The Hebrew commentary on and German translation of the Pentateuch appear in <em>JubA</em>, volumes 15.2–18.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>BMH</em></p></td>
<td valign="top"><p class="table1"><em>Bi’ur Milot Hahigayon</em> (<em>Elucidation of Logical Terms</em>). The Hebrew appears in <em>JubA</em>, 14:23–119.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Gegenbetrachtungen</em></p></td>
<td valign="top"><p class="table1"><em>Gegenbetrachtungen über Bonnets Palingenesie</em> (<em>Counterreflections on Bonnet’s Palingenesis</em>). The German appears in <em>JubA</em>, 7:65–107.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>HLMK</em></p></td>
<td valign="top"><p class="table1"><em>Hakdama Lemegilat Kohelet</em> (<em>Introduction to Commentary on the Book of Ecclesiastes</em>). The Hebrew appears in <em>JubA</em>, 14:147–160.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Jerusalem</em></p></td>
<td valign="top"><p class="table1"><em>Jerusalem, or on Religious Power and Judaism</em>. Translated by Allan Arkush. Hanover, NH: University Press of New England, 1983. The German appears in <em>JubA</em>, 8:99–204.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table1">References appear as <em>Jerusalem</em>, English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><a id="page_x"></a><em>JubA</em></p></td>
<td valign="top"><p class="table1"><em>Gesammelte Schriften Jubiläumsausgabe</em>. Edited by Ismar Elbogen, Fritz Bamberger, Alexander Altmann et al. 24 vols. Stuttgart-Bad Cannstatt: F. Frommann, 1971–.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Morgenstunden</em></p></td>
<td valign="top"><p class="table1"><em>Morgenstunden, oder Vorlesungen über das Daseyn Gottes</em> (<em>Morning Hours, or Lectures on the Existence of God</em>). The German appears in <em>JubA</em>, 3.2:1–175.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>OL</em></p></td>
<td valign="top"><p class="table1"><em>Or Lanetiva</em> (<em>Light for the Path</em>, the introduction to the <em>Bi’ur</em>). The Hebrew appears in <em>JubA</em>, 14:209–268.</p></td>
</tr>
<tr>
<td valign="top"><p class="table">“On Evidence”</p></td>
<td valign="top"><p class="table1">“On Evidence in Metaphysical Sciences.” In <em>PW</em>, 251–306. The German appears in <em>JubA</em>, 2:267–330. References appear as “On Evidence,” English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Phädon</em></p></td>
<td valign="top"><p class="table1"><em>Phädon, or on the Immortality of the Soul</em>. Translated by Patricia Noble. New York: Peter Lang, 2007. The German appears in <em>JubA</em>, 3.1:5–159. References appear as <em>Phädon</em>, English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>PW</em></p></td>
<td valign="top"><p class="table1"><em>Philosophical Writings</em>. Translated and edited by Daniel O. Dahlstrom. Cambridge: Cambridge University Press, 1997.</p></td>
</tr>
<tr>
<td valign="top"><p class="table">“Rhapsody”</p></td>
<td valign="top"><p class="table1">“Rhapsody, or additions to the Letters on Sentiments.” In <em>PW</em>, 131–168. The German appears in <em>JubA</em>, 1:381–424. References appear as “Rhapsody,” English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Ritualgesetze</em></p></td>
<td valign="top"><p class="table1"><em>Ritualgesetze der Juden, betreffend Erbschaften, Vormundschaftssachen, Testamente und <a id="page_xi"></a>Ehesachen, in so weit sie das Mein und Dein angehen</em> (<em>Ritual Laws of the Jews Regarding Inheritances, Guardianships, Wills, and Matrimonial Matters, Insofar as They Concern Mine and Thine</em>). The German appears in <em>JubA</em>, 7:109–251.</p></td>
</tr>
<tr>
<td valign="top"><p class="table">“To Enlighten”</p></td>
<td valign="top"><p class="table1">“On the Question: What Does ‘to Enlighten’ Mean?” In <em>PW</em>, 311–317. The German appears in <em>JubA</em>, 6.1:113–119. References appear as “To Enlighten,” English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Vorrede</em></p></td>
<td valign="top"><p class="table1"><em>Vorrede zu Manasseh Ben Israels Rettung der Juden</em> (<em>Preface to Manasseh Ben Israel’s Vindication of the Jews)</em>. The German appears in <em>JubA</em>, 8:3–25.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>WJCB</em></p></td>
<td valign="top"><p class="table1"><em>Moses Mendelssohn: Writings on Judaism, Christianity, and the Bible</em>. Translated by Allan Arkush, Curtis Bowman, and Elias Sacks. Edited by Michah Gottlieb. Waltham, MA: Brandeis University Press, 2011.</p></td>
</tr>
</tbody></table>
<p class="noindentt">Works by Other Authors</p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="30%"/>
<col width="70%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="tablet"><em>DVRC</em></p></td>
<td valign="top"><p class="table1t">Grotius, Hugo. <em>De Veritate Religionis Christianae</em> (<em>On the Truth of the Christian Religion</em>). Amsterdam: Elzeviriana, 1669. References appear as <em>DVRC</em>, section (page).</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Guide</em></p></td>
<td valign="top"><p class="table1">Maimonides, Moses. <em>The Guide of the Perplexed</em>. Translated by Shlomo Pines. 2 vols. Chicago: University of Chicago Press, 1963. References appear as <em>Guide</em>, part and chapter (volume and page).</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>MR</em></p></td>
<td valign="top"><p class="table1">Michaelis, Johann David. <em>Mosaisches Recht</em> (<em>Mosaic Law</em>). 6 vols. Frankfurt: J. G. Garbe, <a id="page_xii"></a>1775–1800. References appear as <em>MR</em>, section (page).</p></td>
</tr>
<tr>
<td valign="top"><p class="table">“Search”</p></td>
<td valign="top"><p class="table1">Cranz, August Friedrich. “The Search for Light and Right in a Letter to Mr. Moses Mendelssohn, on the Occasion of his Remarkable Preface to Menasseh ben Israel.” In <em>WJCB</em>, 55–67. The German appears in <em>JubA</em>, 8:73–87. References appear as “Search,” English page/German page.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>SSB</em></p></td>
<td valign="top"><p class="table1">Leibniz, Gottfried Wilhelm. <em>Sämtliche Schriften und Briefe</em>. Edited by Deutsche Akademie der Wissenschaften zu Berlin. Berlin: Akademie-Verlag, 1923–.</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Theodicy</em>, PD</p></td>
<td valign="top"><p class="table1">Leibniz, Gottfried Wilhelm. “Preliminary Dissertation on the Conformity of Faith with Reason.” In <em>Theodicy: Essays on the Goodness of God, the Freedom of Man, and the Origin of Evil</em>, 73–122. Translated by E. M. Huggard. Edited by Austin Farrer. La Salle, IL: Open Court, 1985. The French appears in <em>Die philosophischen Schriften</em>, 6:49–101. Edited by Carl Immanuel Gerhardt. 7 vols. Hildesheim: Georg Olms, 1960–1961. References appear as <em>Theodicy</em>, PD paragraph (English page/French page).</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>TTP</em></p></td>
<td valign="top"><p class="table1">Spinoza, Baruch. <em>Theological-Political Treatise</em>. Translated by Samuel Shirley. 2nd ed. Indianapolis, IN: Hackett, 1998. The Latin appears in <em>Opera</em>, 3:1–267. Edited by Carl Gebhardt. 4 vols. Heidelberg: Carl Winter, 1925. References appear as <em>TTP</em>, English page/Latin page.</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// trans.vue?ae1886a2